<template>
  <v-container fluid>
    <v-card :width="cardWidth">
      <v-row>
        <v-col>
          <DevicesBar />
        </v-col>
      </v-row>
      <v-row>
        <ProgressLinearLoaderVue :isLoading="isPortfolioLoading" />
        <v-col v-if="!isPortfolioLoading">
          <router-view />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import DevicesBar from '@/Core.Service.Domain/Devices/Devices.Common/Components/DevicesBar.vue';
import { useCardWidth } from '@/Core.UI.Domain/Composables/responsiveness.ts';
import { computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
import ProgressLinearLoaderVue from '@/Core.UI.Domain/Components/ProgressLinearLoader.vue';

const isPortfolioLoading = computed(
  () => store.getters['DevicesStore/getIsPortfolioLoading']
);

const cardWidth = useCardWidth();
</script>
